module.exports = __webpack_public_path__ + "static/media/logo.f9bf4ff2.svg";